import { useState } from 'react';

import { Input } from '@/components/ui/input';

import type { MasterDetail } from '../api/types';
import SubProjectDescriptionCard from './SubProjectDescriptionCard';

interface Props {
  project: MasterDetail;
}

const DescripcionesSection = ({ project }: Props) => {
  const [search, setSearch] = useState('');

  const subProjects = [...(project.subProjects ?? [])].sort((a, b) => a.name.localeCompare(b.name));

  const filtered = subProjects.filter((sub) => sub.name.toLowerCase().includes(search.toLowerCase()));

  return (
    <section className="space-y-4">
      <h2 className="font-heading text-lg font-semibold">Descripciones de proyectos</h2>
      <Input placeholder="Buscar por nombre..." value={search} onChange={(e) => setSearch(e.target.value)} />
      {subProjects.length === 0 ? (
        <p className="text-sm text-muted-foreground">Esta inmobiliaria no tiene subproyectos.</p>
      ) : filtered.length === 0 ? (
        <p className="text-sm text-muted-foreground">No se encontraron proyectos para &quot;{search}&quot;.</p>
      ) : (
        <div className="space-y-3">
          {filtered.map((sub) => (
            <SubProjectDescriptionCard key={sub.id} subProject={sub} />
          ))}
        </div>
      )}
    </section>
  );
};

export default DescripcionesSection;
